import groq from 'groq'
import { callToAction } from '../../../projections/callToAction.js'
import { mediaAsset } from '../../../projections/mediaAsset'

export const insights = groq`
  _type,
  title,
  cta{...${callToAction()}},
  featuredInsight->{
      metadata{
          "slug": slug.current,
          title
      },
      articleSetup{
          date,
          "category": category->name,
          "categorySlug": category->slug.current
      },
      presentation{
          media[0]{...${mediaAsset()}}
      },
      "readTime": sections[1]{
          "time":round(length(pt::text(content)) / 5 / 180 ),
      }.time,
  },
  callToAction{
    title,
    cta{...${callToAction()}},
  }
`
